import { APIException } from './api-exception';

export class APINotFoundException extends APIException {
    constructor() {
        super('Not Found');
    }
}